
  class CustomSingleCollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    init() {
      if (typeof window.Swiper === 'undefined' || this.swiper) return;

      const sliderEl = this.querySelector('.custom-collection-slider__slider');
      if (!sliderEl) return;

      const prevEl = sliderEl.querySelector('.swiper-button-prev');
      const nextEl = sliderEl.querySelector('.swiper-button-next');

      this.swiper = new window.Swiper(sliderEl, {
        speed: 300,
        slidesPerView: 'auto',
        loop: false,
        wrapperClass: 'custom-collection-slider__wrapper',
        slideClass: 'custom-collection-slider__slide',
        navigation:
          prevEl && nextEl
            ? { nextEl: nextEl, prevEl: prevEl }
            : false,
      });
    }

    connectedCallback() {
      const doInit = () => requestAnimationFrame(() => this.init());
      if (typeof window.Swiper !== 'undefined') {
        doInit();
        return;
      }
      window.addEventListener('load', doInit);
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('custom-single-collection-slider')) {
    customElements.define('custom-single-collection-slider', CustomSingleCollectionSlider);
  }
